import { colors } from '@/theme/colors.theme'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => {
  return {
    icon: {
      color: colors.red,
      fontSize: 100,
    },
    iconError: {
      color: colors.white,
      fontSize: 60,
    },
  }
})

export default useStyles
